<template>
  <v-container fluid>
    <v-data-table-server
      :headers="headers"
      :items="franchises"
      :search="search"
      density="compact"
      :items-length="totalItems"
      :loading="loadingDatatables"
      @update:sortBy="toSort"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-text-field
            v-model="search"
            density="compact"
            :label="this.$t('search')"
            class="pl-2"
            :prepend-inner-icon="mdiMagnify"
            @update:modelValue="toSearchBack"
            variant="solo-filled"
            flat
            hide-details
            single-line
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-btn
            variant="elevated"
            class="mb-2 text-white mr-3"
            :prepend-icon="mdiAccountPlus"
            color="#ffb300"
            @click="openDialog"
            dark
          >
            {{ $t("admin.new-franchise") }}
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon class="me-2" size="small" @click="editItem(item)">
          {{ mdiPencil }}
        </v-icon>
        <v-icon size="small" @click="deleteItem(item)">
          {{ mdiDelete }}
        </v-icon>
      </template>

      <template v-slot:bottom>
        <pagination-dynamic :store="'franchises'"></pagination-dynamic>
      </template>
    </v-data-table-server>
    <add-edit-franchise
      :modelDialog="franchiseDialog"
      @close="franchiseDialog = false"
    ></add-edit-franchise>
  </v-container>
</template>

<script>
import { mdiPencil, mdiDelete, mdiMagnify, mdiAccountPlus } from "@mdi/js";
import PaginationDynamic from "@/components/PaginationDynamic.vue";
import AddEditFranchise from "./admin/AddEditFranchise.vue";
import paginate from "@/mixins/paginations";
import { mapState } from "vuex";

export default {
  name: "FranchiseAdmin",
  mixins: [paginate],
  components: {
    AddEditFranchise,
    PaginationDynamic
  },
  data() {
    return {
      mdiAccountPlus,
      mdiMagnify,
      mdiPencil,
      mdiDelete,
      dialog: false,
      dialogDelete: false,
      franchiseDialog: false,
      itemsPerPage: 15,
      page: 1,
      headers: [
        { title: "Nom", key: "name" },
        { title: "Actions", key: "actions", sortable: false, align: "end" }
      ]
    };
  },
  computed: {
    ...mapState({
      franchises: (state) => state.franchises.items,
      loadingDatatables: (state) => state.loadingTables,
      totalItems: (state) => state.paginations.totalCount,
      editedId: (state) => state.franchises.editedId
    }),
    pageCount() {
      return Math.ceil(this.franchises.length / this.itemsPerPage);
    },
    search: {
      get() {
        return this.$store.state.paginations.search;
      },
      set(value) {
        this.$store.commit("paginations/setSearch", value);
      }
    }
  },
  methods: {
    toSort(item) {
      this.sortBy(item, "franchises");
    },
    toSearchBack(value, time = 500) {
      this.searchBack(value, time, "franchises");
    },
    openDialog() {
      this.$store.commit("franchises/setEditedId", -1);
      this.$store.commit("franchises/setEditedItem", Object.assign({}, {}));
      this.franchiseDialog = true;
    },
    editItem(item) {
      this.$store.commit("franchises/setEditedId", item.id);
      this.$store.commit("franchises/setEditedItem", Object.assign({}, item));
      this.franchiseDialog = true;
    },
    deleteItem(item) {
      if (confirm(this.$t("alert.delete.franchise"))) {
        this.$store
          .dispatch("franchises/deleteItem", item.id)
          .then(() => {
            this.$store.dispatch("showSnackbar", {
              message: this.$t("alert.success.franchise-delete"),
              color: "success"
            });
            this.toSearchBack(this.search, 500, "franchises");
          })
          .catch(() => {
            this.$store.dispatch("showSnackbar", {
              message: this.$t("alert.error.franchise-delete"),
              color: "error"
            });
          });
      }
    }
  }
};
</script>
